import { GET_MY_MEDIA_METHOD, DELETE_MY_MEDIA_METHOD } from './constants';
import { IUploadResponse } from './IUploadResponse';

export interface MediaCenterPrams {
  type?: string;
  tabID?: string;
  groupID?: string;
  botID?: string;
  hd?: number;
  ar?: string;
  bg?: string;
}

export interface IMediaCenter {
  id?: string;
  size?: number;
  type?: string;
  name?: string;
  width?: number;
  height?: number;
  duration?: string;
  url?: string; // response.url
  file?: string; // response.file
  filename?: string; // response.file
  // local use
  reference?: number;
  mediaStatus?: string;
  loadingProgress?: number;
  localThumbnail?: string;
  localFile?: File;
  fileAsArrayBuffer?: ArrayBuffer;
  aspectRatio?: string;
  permanentUrl?: string;
  private_url?: string;
}

export interface MediaCenterRcvd {
  id?: string;
  size?: number;
  type?: string;
  name?: string;
  width?: number;
  height?: number;
  duration?: string;
  filename?: string;
  p: number;
  upload_type?: string;
  response?: IUploadResponse;
  thumbnail?: {
    width: number;
    height: number;
    id: string;
  };
  aspectRatio?: string;
}

export class GetMyMediaGallery {
  readonly method = GET_MY_MEDIA_METHOD;
  constructor(public mediaType: string) {}
}

export class DeleteMyMediaGalleryItem {
  readonly method = DELETE_MY_MEDIA_METHOD;
  constructor(public filename: string) {}
}

export type MediaCenterMethods = GetMyMediaGallery | DeleteMyMediaGalleryItem;
